export const iconFontAwesomeSportsFitnessDumbbell = (
	<i className="fa-solid fa-dumbbell"></i>
);
